export default "__VITE_ASSET__cAebmho3__"